export enum PaymentPeriod {
  CASH = 'CASH',

  ATDELIVERY = 'ATDELIVERY',

  DAILY = 'DAILY',

  WEEKLY = 'WEEKLY',

  BIMONTHLY = 'BIMONTHLY',

  MONTHLY = 'MONTHLY',

  VIREMENT = 'VIREMENT',
}
